import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AdvertBuyDialog(props) {
  return (
    <div>
      {/*  <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open alert dialog
      </Button>*/}
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          İletişim bilgilerini görüntülemek ister misiniz?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            İlan sahibinin iletişim bilgilerini görüntülemek için bakiyenizden
            <b> {props.advertDetail.acoin} TL</b> harcanacaktır. Onaylıyor
            musunuz?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.closeDialog()} color="primary">
            Hayır
          </Button>
          <Button onClick={() => props.takeAdvert()} color="primary" autoFocus>
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
